import { localGet } from './localStorageUtils'

export const getSchoolsOfDistrict = async (districtId) => {
    const allSchools = await localGet('schools', true);
    const districtSchoolsOptions = [];
    for (let school in allSchools){
        if (allSchools[school].district === districtId){
            districtSchoolsOptions.push({
                value: allSchools[school].id,
                label: allSchools[school].name
            });
        }
    }
    return districtSchoolsOptions;
}